import React from 'react';

import { Box, useToken } from '@gluestack-ui/themed';
import HtmlText from '@/common/components/HtmlText';

/**
 * Pure presentational component for displaying task description
 * @param {Object} props
 * @param {string} props.description - HTML content of task description
 * @param {string} [props.variant='comfortable'] - 'compact' or 'comfortable'
 */
const TaskDescription = ({ description = '', variant = 'comfortable' }) => {
  const isCompact = variant === 'compact';
  const fontSizeToken = isCompact ? 'xs' : 'sm';
  const fontSize = useToken('fontSizes', fontSizeToken);

  return (
    <Box>
      <HtmlText content={description} fontSize={fontSize} />
    </Box>
  );
};

export default TaskDescription;
